/*
 * Copyright 2016 Lutrons Ltd. All Rights Reserved.
 *
 */
import AppDispatcher from '../dispatcher/AppDispatcher';
import AppConstants from '../constants/AppConstants';
import { EventEmitter } from 'events';
import assign from 'object-assign';
import moment from 'moment';

const CHANGE_EVENT = 'api-job-data-change';

let _store = {
    jobs        : [],
    activeJob   : null,
    lastFailure     : null,
    history : null,
    historySummary : null,
    dayHistory : {}
};

class JobStoreClass extends EventEmitter {
    constructor() {
        super();
        console.log("[Job Store] - initialisation");
    }

    addChangeListener(cb) {
        this.on(CHANGE_EVENT, cb);
    }

    removeChangeListener(cb) {
        this.removeListener(CHANGE_EVENT, cb);
    }

    jobs() {
        return _store.jobs ;
    }

    history() {
        return _store.history ;
    }

    currentJob() {
        return _store.activeJob ;
    }

    lastFailure() {
        return _store.lastFailure ;
    }

    clear() {
        _store.activeJob = null ;
        _store.history = null ;
        _store.historySummary = null ;
        _store.dayHistory = {};
    }

    historyForDay(day) {
        if (!_store.dayHistory) {
            return null ;
        }

        // var md = moment(day, 'YYYYMMDDHHmmss') ;
        // var td = md.format('YYYYMMDD') + "000000" ;
        console.log("Checking store for history day: ", day, _store.dayHistory);
        let h = _store.dayHistory[parseInt(day, 10)] ;
        return (h && h.length === 0) ? null : h ;
    }

    historySummary() {
        return _store.historySummary ;
    }

    historyDayStatusCounts() {
        if (!_store.historySummary) {
            return {} ;
        }

        return _store.historySummary.days ;
    }

    historyDayStatus(hd) {
        console.log("historyDayaStatus-", hd);
        var keys = Object.keys(hd) ;
        var ds = {ok : [], warn : [], error: []};
        for (var ki in keys) {
            var key = keys[ki];
            var item = hd[key];
            let startOfDay = moment(key, 'YYYYMMDD').startOf('day').toDate();

            if (item.error > 0) {
                ds.error.push(startOfDay) ;
            }
            else if (item.warn > 0) {
                ds.warn.push(startOfDay) ;
            }
            else {
                ds.ok.push(startOfDay) ;
            }
        }

        return ds ;
    }

}

const JobStore = new JobStoreClass();

AppDispatcher.register((payload) => {
  const action = payload.action;

  switch (action.actionType) {
    case AppConstants.SEARCH_JOBS:
        _store.jobs = action.result;
        JobStore.emit(CHANGE_EVENT, {event: AppConstants.SEARCH_JOBS});
        break ;

    case AppConstants.SAVE_JOB:
        _store.activeJob = action.result;
        JobStore.emit(CHANGE_EVENT, {event: AppConstants.SAVE_JOB});
        break ;

    case AppConstants.SEARCH_JOBS_ERR:
        _store.jobs = [];
        _store.lastFailure = action.error  ;
        JobStore.emit(CHANGE_EVENT, {event: AppConstants.SEARCH_JOBS_ERR, error: action.error});
        break ;

    case AppConstants.SAVE_JOB_ERR:
        _store.activeJob = null ;
        _store.lastFailure = action.error ;
        JobStore.emit(CHANGE_EVENT, {event: AppConstants.SAVE_JOB_ERR, error: action.error});
        break ;

    case AppConstants.GET_JOB_HISTORY:
        _store.history = action.result ;
        JobStore.emit(CHANGE_EVENT, {event: AppConstants.GET_JOB_HISTORY});
        break ;

      case AppConstants.GET_JOB_HISTORY_DAY:
        var h = action.result ;
        var ts = moment.utc(h.startdate,'YYYYMMDDHHmmss').local().format('YYYYMMDD') + '000000';
        _store.dayHistory[ts] = h.dayhistory ;
        JobStore.emit(CHANGE_EVENT, {event: AppConstants.GET_JOB_HISTORY_DAY});
        break ;

    case AppConstants.GET_JOB_HISTORY_SUMMARY:
        console.log("GET_JOB_HISTORY_SUMMARY: ", action.result);
        _store.historySummary = action.result ;
        JobStore.emit(CHANGE_EVENT, {event: AppConstants.GET_JOB_HISTORY_SUMMARY});
        break ;

    case AppConstants.GET_JOB_HISTORY_ERR:
        _store.history = null ;
        _store.lastFailure = action.error ;
        JobStore.emit(CHANGE_EVENT, {event: AppConstants.GET_JOB_HISTORY_ERR});
        break ;

    case AppConstants.JOB_IMAGE_SAVE:
        let photoUrl = action.result.location ;
        JobStore.emit(CHANGE_EVENT, {event: AppConstants.JOB_IMAGE_SAVE, photo: photoUrl});
        break ;

    case AppConstants.JOB_IMAGE_SAVE_ERR:
        JobStore.emit(CHANGE_EVENT, {event: AppConstants.JOB_IMAGE_SAVE_ERR, photo: null, error: action.error});
        break ;

    case AppConstants.LOAD_JOB:
        _store.activeJob = action.result ;
        JobStore.emit(CHANGE_EVENT, {event: AppConstants.LOAD_JOB, data: action.result});
        break ;

    case AppConstants.DELETE_JOB:
        _store.activeJob = null ;
        let jobId = action.result ;
        _store.jobs = _store.jobs.filter((j) => j.jobId !== jobId);
        JobStore.emit(CHANGE_EVENT, {event: AppConstants.DELETE_JOB});
        break ;

    case AppConstants.DELETE_JOB_ERR:
        JobStore.emit(CHANGE_EVENT, {event: AppConstants.DELETE_JOB_ERR, error: action.error});
        break ;

    default:
        return true;
  }
});

export default JobStore;




// WEBPACK FOOTER //
// ./src/app/stores/JobStore.js